export function checkLatValue(range: 'min' | 'max', value: number) {
  const rangeData = {
    min: -90,
    max: 90,
  };
  return value >= rangeData.min && value <= rangeData.max ? value : rangeData[range];
}

export function checkLonValue(range: string, value: number) {
  const rangeData = {
    min: -180,
    max: 180,
  };
  return value >= rangeData.min && value <= rangeData.max ? value : rangeData[range];
}
